import { Component, OnInit } from '@angular/core';
import { StringUtilities } from '@app/core/utilities/string-utilities';
import { FilePreviewComponentOutput, NgxSmartModalService } from '@bssh/comp-lib';
import environment from '@environments/environment';
import { isNullOrUndefined } from 'util';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { ModalTexts } from '../modal-texts';
import { IFilePreviewModalInput, IFilePreviewModalOutput } from '../model/action-modal';
import { IApiFile, IRequestedFile } from '../model/file-preview.interface';

@Component({
  selector: 'app-file-preview-modal',
  templateUrl: './file-preview-modal.component.html',
  styleUrls: ['./file-preview-modal.component.scss']
})
export class FilePreviewModalComponent extends BaseModalComponent implements OnInit {

  modalType = 'FilePreviewModal';
  modalTitle: string = null; // TOOD: get Modal Title
  confirmButtonText = ModalTexts.FILE_PREVIEW.CONFIRM_BUTTON_TEXT;

  public apiBaseUrl: string = null;
  public file: IRequestedFile = null;
  public fileContainerPath: string = null;
  public isPreviewableTextFile: boolean = null;
  public isFolderLinkEnabled: boolean = null;

  constructor(
    public ngxSmartModalService: NgxSmartModalService
) {
    super(ngxSmartModalService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.setUpInputSubscribers();
  }

  dataChanged($event) {
    const _data: FilePreviewComponentOutput = $event;

    // if valid downloadLink then show download button
    if (_data.downloadLink) {
      this.disableConfirmButton = false;
    } else {
      this.disableConfirmButton = true;
    }

    const filePreviewData: IFilePreviewModalOutput = {
      fileName: this.file.Name,
      downloadLink: _data.downloadLink,
    };
    this.modal.setData(filePreviewData, true);
  }

  private setUpInputSubscribers() {
    this.subs.sink = this.data.subscribe((input: IFilePreviewModalInput) => {
      if (isNullOrUndefined(input)) {
        return;
      }

      this.apiBaseUrl = input.apiBaseUrl;
      this.file = this.toIRequestedFile(input.requestedFile);
      this.isPreviewableTextFile = input.isPreviewableTextFile;
      this.modalTitle = this.file.Name;
      this.isFolderLinkEnabled = input.isFolderLinkEnabled;

      if(this.isFolderLinkEnabled) {
        const parentDataset = this.file.ParentDataset;
        const datasetId = parentDataset.Id;
        const appSessionId = parentDataset.AppSession.Id;
        const path = this.file.Path.split('/').slice(0, -1).join('/');

        this.fileContainerPath = `${StringUtilities.trimTrailingSlash(environment.siteUrl)}/analyses/${appSessionId}/files/${datasetId}`;
        this.fileContainerPath = path ? `${this.fileContainerPath}/${path}` : this.fileContainerPath;
      }
    });
  }

  toIRequestedFile(file: IApiFile): IRequestedFile {
    if (!file) {
      return null;
    }
    const requestedFile: IRequestedFile = {
      ...file,
      extension: this.getFileExtension(file.Name)
    };

    return requestedFile;
  }

  private getFileExtension(name: string): string {
    if (!name) {
      return null;
    }

    const values: string[] = name.split(/\.(?=[^\.]+$)/);
    return values[values.length - 1];
  }

}
